import type { ScreenFooterProps } from '@openeducation/pp-rn-components';

import { version } from '../../package.json';

export const footerProps: ScreenFooterProps = {
  version: process.env.APP_VERSION || version,
  currentDate: new Date(),
};
